module.exports = __webpack_public_path__ + "static/img/1-2.4ecda6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/1-2.png
// module id = 1dSr
// module chunks = 0